'use strict';

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _wrapNativeSuper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var UnexpectedPeerError = /*#__PURE__*/function (_Error) {
  _inherits(UnexpectedPeerError, _Error);

  var _super = _createSuper(UnexpectedPeerError);

  function UnexpectedPeerError() {
    var _this;

    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Unexpected Peer';

    _classCallCheck(this, UnexpectedPeerError);

    _this = _super.call(this, message);
    _this.code = UnexpectedPeerError.code;
    return _this;
  }

  _createClass(UnexpectedPeerError, null, [{
    key: "code",
    get: function get() {
      return 'ERR_UNEXPECTED_PEER';
    }
  }]);

  return UnexpectedPeerError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var InvalidCryptoExchangeError = /*#__PURE__*/function (_Error2) {
  _inherits(InvalidCryptoExchangeError, _Error2);

  var _super2 = _createSuper(InvalidCryptoExchangeError);

  function InvalidCryptoExchangeError() {
    var _this2;

    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Invalid crypto exchange';

    _classCallCheck(this, InvalidCryptoExchangeError);

    _this2 = _super2.call(this, message);
    _this2.code = InvalidCryptoExchangeError.code;
    return _this2;
  }

  _createClass(InvalidCryptoExchangeError, null, [{
    key: "code",
    get: function get() {
      return 'ERR_INVALID_CRYPTO_EXCHANGE';
    }
  }]);

  return InvalidCryptoExchangeError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var InvalidCryptoTransmissionError = /*#__PURE__*/function (_Error3) {
  _inherits(InvalidCryptoTransmissionError, _Error3);

  var _super3 = _createSuper(InvalidCryptoTransmissionError);

  function InvalidCryptoTransmissionError() {
    var _this3;

    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Invalid crypto transmission';

    _classCallCheck(this, InvalidCryptoTransmissionError);

    _this3 = _super3.call(this, message);
    _this3.code = InvalidCryptoTransmissionError.code;
    return _this3;
  }

  _createClass(InvalidCryptoTransmissionError, null, [{
    key: "code",
    get: function get() {
      return 'ERR_INVALID_CRYPTO_TRANSMISSION';
    }
  }]);

  return InvalidCryptoTransmissionError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

module.exports = {
  UnexpectedPeerError: UnexpectedPeerError,
  InvalidCryptoExchangeError: InvalidCryptoExchangeError,
  InvalidCryptoTransmissionError: InvalidCryptoTransmissionError
};